import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { groupBy } from "lodash";
import { Dropdown, Spin } from "@gw/web-basic-components";
import type { HelpCenterProps } from "./dto";
import { ReactComponent as FeedbackSvg } from "../../../../assets/icon_feedback.svg";
import { useRequest, apis } from "../../../../../appearance/utils";

const FILE_CENTER_LINK =
  "https://gie8j6kp4el.feishu.cn/wiki/XO6iw8JvMiUUOMkrXvEcVCEtn2g";

const InnerDropdown = ({
  dataList,
  appCode,
  loading,
  onOpenFeedBackModal,
}: any) => {
  const [files, setFiles] = useState<{ [key: string]: any[] }>();
  const { t } = useTranslation();

  const filesKeys = useMemo(() => {
    return files ? Object.keys(files) : [];
  }, [files]);

  useEffect(() => {
    setFiles(groupBy(dataList, "productType"));
  }, [dataList]);

  return (
    <div className={"wbuc-file-dropdown"} data-app-theme={appCode}>
      <Spin spinning={loading}>
        {Boolean(filesKeys.length) && (
          <a href={FILE_CENTER_LINK} className="file center" target="_blank">
            {t("user_guide", { defaultValue: "文档中心" })}
          </a>
        )}
        <div className="file" onClick={onOpenFeedBackModal}>
          {t("feedback_suggestions", { defaultValue: "反馈建议" })}
        </div>
      </Spin>
    </div>
  );
};

/**
 * 帮助中心
 */
const HelpCenter = (props: HelpCenterProps) => {
  const { onOpenFeedBackModal } = props;
  const [files, setFiles] = useState(null);
  const [{ loading }, fetchPermission] = useRequest<any, any>(
    apis.document.getDocuments
  );
  const { t } = useTranslation();
  return (
    <Dropdown
      overlayClassName={"wbuc-file-dropdown"}
      trigger={["hover"]}
      onOpenChange={(openFlag) => {
        if (openFlag) {
          fetchPermission({ size: -1 }).then((res) => {
            const { dataList } = res;
            setFiles(dataList);
          });
        }
      }}
      dropdownRender={() =>
        (
          <InnerDropdown
            loading={loading}
            dataList={files}
            appCode={props.themeCode || props.app}
            onOpenFeedBackModal={onOpenFeedBackModal}
          />
        ) as React.ReactNode
      }
    >
      <div className={"wbuc-feedback-trigger"}>
        <FeedbackSvg />
        {t("help", { defaultValue: "帮助" })}
      </div>
    </Dropdown>
  );
};

export default HelpCenter;
